export const comments_5150489 = {"data":{"data":[],"links":{}}}